import React from 'react';
import SidebarParametres from '../../../layout/SidebarParametres';
import { useOAD } from '../../../layout/OADLayout';

/**
 * OptimisationAssurance
 *
 * Fil de fer (Phase 1) : la navigation est câblée, le contenu arrive en
 * Phase 6.
 * Contenu prévu : optimisation2.js + resistance.js (2 parties)
 */
export default function OptimisationAssurance() {
  const { idExploit } = useOAD();

  return (
    <div className="oad-contenu">
      <SidebarParametres
        niveau1="2026-2027"
        niveau2="optimisation-assurance"
        niveau3={null}
        idExploit={idExploit}
      />
      <main className="oad-cards">
        <div className="oad-card oad-card-placeholder">
          <h2>OptimisationAssurance</h2>
          <p>optimisation2.js + resistance.js (2 parties)</p>
        </div>
      </main>
    </div>
  );
}
